var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selectedComponent,{tag:"component",staticClass:"state",attrs:{"title":_vm.titleProcess,"hasTitle":_vm.hasTitle,"hasTitleOnAdaptive":_vm.hasTitleOnAdaptive,"isShortTitle":_vm.isShortTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }